import {
  Box,
  Button,
  Checkbox,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material"
import React, { useEffect, useState } from "react"
import FilterAltIcon from "@mui/icons-material/FilterAlt"
import { useSelector } from "react-redux"
import { ApplyButton } from "../../Button"
import { useDispatch } from "react-redux"
import { setSelectedProviderColumns } from "../../../redux/slices/providersSlice"
import { SetButton } from "./Atom"

type Props = {}

const ColumnFilterMenu = (props: Props) => {
  const dispatch = useDispatch()

  const [anchorEl, setAnchorEl] = useState<any>()
  const openMenu = Boolean(anchorEl)

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const allProviderColumns = useSelector((state: any) => {
    return state.providers.allProviderColumns
  })
  const selectedProviderColumns = useSelector((state: any) => {
    return state.providers.selectedProviderColumns
  })

  const [checkedMenuItems, setCheckedMenuItems] = useState<Array<number>>([])
  const [selectedLocalProviderColumns, setSelectedLocalProviderColumns] =
    useState<Array<any>>([])

  const headersToCapsLock = ["Cytd", "Py", "pytd", "ttm"]

  const capitalizeMatchingWord = (sentence: string) => {
    // Split the sentence into words
    const words = sentence.split(/\s+/)
    // Iterate over each word in the sentence
    const capitalizedWords = words.map((word) => {
      // Check if the word exists in the headersToCapsLock array
      const matchIndex = headersToCapsLock.findIndex(
        (header: any) => header.toLowerCase() === word.toLowerCase(),
      )

      // If the word exists in headersToCapsLock, capitalize it
      if (matchIndex !== -1) {
        return word.toUpperCase()
      }

      // Otherwise, return the word as is
      return word
    })
    // Join the words back into a sentence
    return capitalizedWords.join(" ")
  }

  const handleCheckedMenuItems = (column: any) => {
    const columnId = column?.column_id

    if (column === "Select All") {
      if (allProviderColumns.length === checkedMenuItems.length) {
        setCheckedMenuItems([])
        setSelectedLocalProviderColumns([])
        return
      }

      const All = allProviderColumns?.map((column: any) => column?.column_id)
      setCheckedMenuItems(All)
      setSelectedLocalProviderColumns(allProviderColumns)
      return
    }
    if (checkedMenuItems.includes(columnId)) {
      setCheckedMenuItems(
        checkedMenuItems.filter((item: any) => item !== columnId),
      )
      setSelectedLocalProviderColumns(
        selectedLocalProviderColumns.filter(
          (localProviderColumn: any) =>
            localProviderColumn?.column_id != columnId,
        ),
      )
    } else {
      setCheckedMenuItems([...checkedMenuItems, columnId])
      setSelectedLocalProviderColumns([...selectedLocalProviderColumns, column])
    }
  }

  const handleApply = () => {
    dispatch(setSelectedProviderColumns([...selectedLocalProviderColumns]))
    handleClose()
  }
  const isAllSelected =
    allProviderColumns?.length > 0 &&
    checkedMenuItems?.length >= allProviderColumns?.length

  useEffect(() => {
    const All = allProviderColumns?.map((column: any) => column?.column_id)
    setCheckedMenuItems(All)
    setSelectedLocalProviderColumns(allProviderColumns)
  }, [allProviderColumns])
  return (
    <Box sx={{ marginLeft: "auto" }}>
      <Box
        id="columns-filter-button"
        aria-controls={openMenu ? "columns-filter-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={openMenu ? "true" : undefined}
        onClick={handleClick}
        sx={{
          display: "flex",
          alignItems: "center",
          height: "100%",
          cursor: "pointer",
        }}
      >
        <FilterAltIcon sx={{ fontSize: "20px", color: "#3D76EF" }} />
        <Typography fontSize={14} color={"#3D76EF"}>
          Columns
        </Typography>
      </Box>
      <Menu
        id="columns-filter-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "columns-filter-button",
        }}
        sx={{ padding: "0 !important" }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <Box
          // id={"0"}
          sx={{
            display: "flex",
            width: "200px",
            alignItems: "center",
            padding: "0 10px",
            height: "30px",
            backgroundColor: "#FFFFFF",
          }}
          // onClick={() => handleClickEdit()}
        >
          <Typography fontSize={14} fontWeight={600}>
            Show Columns
          </Typography>
        </Box>
        {allProviderColumns?.length ? (
          <>
            <MenuItem
              sx={{
                display: "flex",
                width: "200px",
                // justifyContent: "space-around",
                padding: "2px 5px !important",
                margin: "0 !important",
                whiteSpace: "normal",
                fontSize: "14px",
                // backgroundColor: checkedMenuItems?.includes(column?.column_id)
                //   ? "#dce7fe"
                //   : "",
              }}
              onClick={() => handleCheckedMenuItems("Select All")}
            >
              <Checkbox disableRipple checked={isAllSelected} />
              Select All
            </MenuItem>
            {allProviderColumns?.map((column: any) => (
              <MenuItem
                id={column?.column_id}
                sx={{
                  display: "flex",
                  width: "200px",
                  // justifyContent: "space-around",
                  padding: "2px 5px !important",
                  margin: "0 !important",
                  whiteSpace: "normal",
                  backgroundColor: checkedMenuItems?.includes(column?.column_id)
                    ? "#dce7fe"
                    : "",
                }}
                onClick={() => handleCheckedMenuItems(column)}
              >
                <Checkbox
                  disableRipple
                  checked={checkedMenuItems?.includes(column?.column_id)}
                />
                <Typography
                  fontSize={14}
                  fontWeight={500}
                  textTransform={"capitalize"}
                >
                  {capitalizeMatchingWord(column?.column_name)}
                </Typography>
              </MenuItem>
            ))}
          </>
        ) : (
          <Box
            sx={{
              height: "50vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Select A Metric
          </Box>
        )}
        <Box sx={{ width: "100%", padding: "0 10px" }}>
          <SetButton disabled={false} onClick={handleApply}>
            <Typography color={"#FFFFFF"} fontSize={14} fontWeight={500}>
              Apply
            </Typography>
          </SetButton>
        </Box>
      </Menu>
    </Box>
  )
}

export default ColumnFilterMenu
